import { PhoneOutlined } from '@ant-design/icons'
import { Button, Drawer } from 'antd'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useSmallScreen } from '../../lib/hooks'
import DemandeExpressForm from '../DemandeExpress/DemandeExpressForm'

const StyledIcon = styled(PhoneOutlined)`
  font-size: 42px !important;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

const DemandeDeRappel = () => {
  const [visible, setVisible] = useState(false)
  const smallScreen = useSmallScreen()
  return (
    <>
      <Drawer
        title="Demande De Rappel"
        visible={visible}
        onClose={() => setVisible(false)}
        width={smallScreen ? '100%' : '70%'}
        destroyOnClose
      >
        <DemandeExpressForm
          withPersonneDescription
          withTextInput
          withSocieteDescription
          withGestionnaires
          handleClose={() => setVisible(false)}
        />
      </Drawer>

      <Button
        onClick={() => setVisible(!visible)}
        style={{ position: 'fixed', bottom: 10, right: 75 }}
        size="large"
        shape="circle"
        icon={<StyledIcon />}
        type="link"
      />
    </>
  )
}

export default DemandeDeRappel
